import "./ReservationPage.scss";

export default function ReservationCancelledPage() {
  return (
    <main className="reservation-page">
      <section className="reservation-card">
        <span className="reservation-eyebrow">Reservation cancelled</span>

        <h1>Your Reservation Was Not Completed</h1>

        <p>
          No worries. You are still on the Kotam: Conquest early access list and
          will continue receiving launch updates.
        </p>

        <div className="reservation-next">
          <h2>Still Want the 3D Barrack Promo?</h2>
          <p>
            You can return to the thank-you page and reserve for $1 when you are
            ready.
          </p>

          <a href="/thank-you" className="btn btn-primary">
            Return to 3D Barrack Offer
          </a>
        </div>

        <a href="/" className="reservation-link">Back to landing page</a>
      </section>
    </main>
  );
}